import { useState } from 'react'

export const useContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    lookingFor: '',
    message: ''
  })
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitStatus, setSubmitStatus] = useState('')

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)
    setSubmitStatus('')

    try {
      const formDataWithToken = new FormData()
      
      // Add all form fields
      Object.keys(formData).forEach(key => {
        formDataWithToken.append(key, formData[key])
      })
      
      // Add hidden fields
      formDataWithToken.append('access_key', import.meta.env.VITE_WEB3FORMS_KEY)
      formDataWithToken.append('subject', 'New Contact Form Submission from TalentHouse')
      formDataWithToken.append('from_name', 'TalentHouse Website')
      formDataWithToken.append('botcheck', '')

      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formDataWithToken
      })

      if (response.ok) {
        setSubmitStatus('success')
        setFormData({
          firstName: '',
          lastName: '',
          email: '',
          lookingFor: '',
          message: ''
        })
      } else {
        throw new Error('Form submission failed')
      }
    } catch {
      setSubmitStatus('error')
    } finally {
      setIsSubmitting(false)
    }
  }

  return {
    formData,
    handleChange,
    handleSubmit,
    isSubmitting,
    submitStatus
  }
}
